import {ContentContainer, useMessage} from '@coolcolduk/ui-mui';
import {PlayCircleOutline} from '@mui/icons-material';
import {Alert, Box, Button, Card, CardContent, TextField, Typography} from '@mui/material';
import {useState} from 'react';
import {env} from '../../../config/env';

export default function AdminMigrationPage() {
  const [jobId, setJobId] = useState('');
  const {showMessage} = useMessage();

  const handleTriggerJobProcessor = async () => {
    if (!jobId) {
      showMessage('Please create a migration job first', 6000, 'error');
      return;
    }

    try {
      const response = await fetch(`${env.trigger.jobProcessor}?id=${jobId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        showMessage('Job processor triggered failed!', 6000, 'error');
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      showMessage('Job processor triggered successfully!', 6000, 'success');
    } catch (error) {
      console.error('Job processor error:', error);
      showMessage(`Job processor failed: ${error instanceof Error ? error.message : 'Unknown error'}`, 6000, 'error');
    }
  };

  return (
    <ContentContainer data-testid="migration-management-page">
      <Typography variant="h5" component="h2" sx={{mb: 3}}>
        Migration Management
      </Typography>

      <Alert severity="warning" sx={{mb: 3}}>
        Running migrations can affect the database structure and data. Only run migrations when necessary and ensure you
        have proper backups.
      </Alert>

      {env.isDev && (
        <Card sx={{mt: 3}}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Dev Mode: Job Processor
            </Typography>

            <Box sx={{mt: 2, display: 'flex', gap: 2, alignItems: 'center'}}>
              <TextField
                label="Job ID"
                value={jobId}
                onChange={(e) => setJobId(e.target.value)}
                placeholder="Job ID will be filled automatically"
                sx={{minWidth: 300}}
              />

              <Button
                variant="outlined"
                startIcon={<PlayCircleOutline />}
                onClick={handleTriggerJobProcessor}
                disabled={!jobId}
                sx={{textTransform: 'none'}}
              >
                Trigger Job Processor
              </Button>
            </Box>
          </CardContent>
        </Card>
      )}
    </ContentContainer>
  );
}
